<sc-flex class="structure-selection-field no-field-space" [formGroup]="detailsFormGroup">
  <mat-form-field class="value-field" appearance="fill">
    <mat-label>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.stationName"></sc-dictionary-label>
    </mat-label>
    <input matInput formControlName="value" />
  </mat-form-field>
  <sc-content-spacer></sc-content-spacer>
  <sc-action-icon iconClass="fa-sitemap" (click)="doSelection()"></sc-action-icon>
</sc-flex>
